import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { toJS } from "mobx";
import RankerXLink from "components/RankerXLink";
import moment from "moment";
import { saveAs } from "file-saver";
import {
	Alert,
	Table,
	Card,
	Form,
	Button,
	Row,
	Icon,
	Popconfirm,
	Spin,
	Tooltip,
	Divider,
	Menu,
	Dropdown,
	message,
	notification
} from "antd";

import BasicLayout from "layouts/BasicLayout";
import PageHeaderLayout from "layouts/PageHeaderLayout";
import AddEditCampaignDialog from "./components/AddEditCampaignDialog";
import AddCampaignDialog from "./components/AddCampaignDialog";
import DuplicateCampaignDialog from "./components/DuplicateCampaignDialog";
import { locationPrefix } from "common/general";
import co from "co";
import { delay } from "services/api";

const FormItem = Form.Item;

@inject("rootStore")
@observer
export default class CampaignsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedRowKeys: [],
			notiMsg: null
		};
	}

	componentDidMount = () => {
		const {
			rootStore: { uiStore }
		} = this.props;
		
		co(
			function*() {			
				try {	
					const response = yield fetch(window.rxNotiUrl + '/info?' + window.userId);					
					const data = yield response.text();
					this.setState({
						notiMsg: data 
					});										
				}
				catch (err) {
					console.log(err);
				}

				

			}.bind(this)
		)
		
		co(
			function*() {
				let response = yield uiStore.checkImageCaptchaService();
				if (response != null) {
					if (response.error) {
						message.error("Captcha balance is low or captcha key is incorrect", 10)
					} else {
						if (response.useCaptcha) {
							if (response.balance == -1) {
								message.error("Captcha balance is low or captcha key is incorrect", 10);		
							} else if (response.balance < 1) {
								message.warn("Captcha balance is low", 10);
							}					
						}
					}			
				}	
				response = yield uiStore.checkGoogleCaptchaService();
				if (response != null) {
					if (response == null || response.error) {
						message.error("Google Captcha balance is low or captcha key is incorrect", 10);
					} else {
						if (response.useGoogleCaptcha) {
							if (response.balance == -1) {
								message.error("Google captcha balance is low or captcha key is incorrect", 10);
							} else if (response.balance < 1) {
								message.warn("Google captcha balance is low", 10);	
							}
						}
					}	
				}				
			}
		);
	}

	deleteCampaigns = () => {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		campaignsStore.remoteDeleteCampaigns(this.state.selectedRowKeys);
	};

	showAddCampaignDialog = () => {
		const {
			rootStore: { campaignsStore }
		} = this.props;
		campaignsStore.showAddCampaignDialog();
	};

	showEditCampaignDialog = e => {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		campaignsStore.showEditCampaignDialog({
			name: e.currentTarget.dataset.name,
			id: e.currentTarget.dataset.id
		});
	};

	// hideAddCampaignDialog = () => {
	// 	this.props.dispatch({
	// 		type: "Campaigns/hideAddCampaignDialog"
	// 	});
	// };

	// createCampaign = payload => {
	// 	this.props.dispatch({
	// 		type: "Campaigns/remoteCreateCampaign",
	// 		payload: payload
	// 	});
	// };

	// showEditCampaignDialog = e => {
	// 	this.props.dispatch({
	// 		type: "Campaigns/showEditCampaignDialog",
	// 		payload: {
	// 			name: e.target.dataset.name,
	// 			id: e.target.dataset.id
	// 		}
	// 	});
	// };

	// hideEditCampaignDialog = () => {
	// 	this.props.dispatch({
	// 		type: "Campaigns/hideEditCampaignDialog"
	// 	});
	// };

	// renameCampaign = payload => {
	// 	this.props.dispatch({
	// 		type: "Campaigns/remoteRenameCampaign",
	// 		payload: payload
	// 	});
	// };

	showDuplicateCampaignDialog = e => {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		campaignsStore.showDuplicateCampaignDialog({
			name: e.currentTarget.dataset.name + " Copy",
			id: e.currentTarget.dataset.id
		});
	};

	downloadLinkSets = () => {
		let ids = this.state.selectedRowKeys;
		fetch("/action/export/backlinks_from_campaigns", {
			method: "POST",
			body: JSON.stringify(ids),
			headers: {
				"Content-Type": "application/json; charset=utf-8"
			}
		}).then(response => {
			if (response.status == 200) {
				let filename = "all_links.zip";
				response.blob().then(data => {
					saveAs(data, filename);
				});
			} else {
				message.error("Failed to download the backlinks");
			}			
		});
	};

	render() {
		const {
			rootStore: { campaignsStore }
		} = this.props;

		const ui = campaignsStore.ui;

		const columns = [
			{
				title: "ID",
				dataIndex: "id",
				width: 120,
				defaultSortOrder: "descend",
				sorter: (a, b) => a.id - b.id
			},
			{
				title: "Name",
				dataIndex: "name",
				sorter: (a, b) => (a.name > b.name ? 1 : -1),
				render: (text, record) => {
					// return <Link to={"/campaign/" + record.id}>{text}</Link>;
					return (
						<RankerXLink
							routeName="campaign"
							params={{ id: record.id.toString() }}
						>
							{text}
						</RankerXLink>
					);
				}
			},
			{
				title: "Scheduler Status",
				dataIndex: "campaignStatus",
				sorter: (a, b) => (a.campaignStatus > b.campaignStatus ? 1 : -1),
				render: (text, record) => {
					let description = "";
					if (record.schedule) {
						description = "1 day, ";
						if (record.schedule.nDay > 1) {
							description =  record.schedule.nDay + " days, ";
						}
						let tmpDate = record.schedule.startDate;
						tmpDate = moment.utc(tmpDate, "DD/MM/YYYY HH:mm").local();
						description = description + "starting at " + tmpDate.format("DD/MM/YYYY HH:mm");
					}					
					return (
						<Fragment>
							<div
								className="ant-tag ant-tag-has-color"
								style={
									text == "ACTIVE"
										? { backgroundColor: "rgb(16, 142, 233)" }
										: { backgroundColor: "#f2f4f5", color: "black" }
								}
							>
								{text}
							</div>
							{' '}
							{description}
						</Fragment>
					);
				}
			},
			{
				title: "Action",
				render: (text, record) => {
					let campaign = record;
					let duplicateCampaignPart = "";

					if (campaign.creatingType == "XWizard") {
						duplicateCampaignPart = (
							<Fragment>
								<Divider type="vertical" />
								<Tooltip title="Duplicate Campaign">
									<a
										type="primary"										
										data-name={record.name}
										data-id={record.id}
										onClick={this.showDuplicateCampaignDialog}
									>
										<Icon type="copy" />
									</a>
								</Tooltip>
							</Fragment>
						);
					}
					return (
						<span>
							<Tooltip title="Rename">
								<a
									type="primary"
									data-name={record.name}
									data-id={record.id}
									onClick={this.showEditCampaignDialog}
								>
									<Icon type="edit" />
								</a>								
							</Tooltip>
							{duplicateCampaignPart}
						</span>
					);
				}
			},
			{
				title: "Project Count",
				render: (text, record) => {
					let projectCount = record.projectCount;
					let scheduledCount = <Fragment />;
					if (projectCount.scheduled > 0) {
						scheduledCount = (
							<div
								className="ant-tag ant-tag-has-color"
								style={{ backgroundColor: "rgb(135, 208, 104)" }}
							>
								Scheduled: {projectCount.scheduled}
							</div>
						);
					}
					let runningCount = <Fragment />;
					if (projectCount.running > 0) {
						runningCount = (
							<div
								className="ant-tag ant-tag-has-color"
								style={{ backgroundColor: "rgb(16, 142, 233)" }}
							>
								Running: {projectCount.running}
							</div>
						);
					}
					let startingCount = <Fragment />;
					if (projectCount.starting > 0) {
						startingCount = (
							<div
								className="ant-tag ant-tag-has-color"
								style={{ backgroundColor: "rgb(16, 142, 233)" }}
							>
								Starting: {projectCount.starting}
							</div>
						);
					}
					let failedCount = <Fragment />;
					if (projectCount.failed > 0) {
						failedCount = (
							<div
								className="ant-tag ant-tag-gray"
								style={{ backgroundColor: "rgb(16, 142, 233)" }}
							>
								Failed: {projectCount.failed}
							</div>
						);
					}
					return (
						<Fragment>
							{scheduledCount}
							{' '}
							{runningCount}
							{' '}
							{startingCount}
							{' '}
							{failedCount}
						</Fragment>
					);
				}
			}
		];

		const { selectedRowKeys } = this.state;
		const rowSelection = {
			selectedRowKeys,
			onChange: (selectedRowKeys, selectedRows) => {
				this.setState({ selectedRowKeys });
			},
			getCheckboxProps: record => ({
				name: record.name
			})
		};

		let spinning = ui.loadingCampaigns == true || ui.deletingCampaigns == true;
		const campaigns = toJS(campaignsStore.campaigns);
		const breadcrumbList = [
			{
				title: "Home",
				href: locationPrefix + "/"
			}
		];

		let downloadLinkSetsMenu = (
			<Menu
				onClick={this.downloadLinkSets}
				disabled={selectedRowKeys.length == 0}
			>
				<Menu.Item key="urlsOnly">Backlinks</Menu.Item>				
			</Menu>
		);
		
		let captchaAlert = <></>;
		if (!ui.loadingCampaigns) {		
			let primaryGoogleCaptchaService = campaignsStore.options.googleNoCaptchaService;						
			if (primaryGoogleCaptchaService == "DeathByCaptcha" || primaryGoogleCaptchaService == "ImageTypers" || primaryGoogleCaptchaService == "AntiCaptcha") {
				let message = <h1>You are using {primaryGoogleCaptchaService}, we <b>DON'T RECOMMEND</b> using {primaryGoogleCaptchaService}, which is slow and expensive. <br/>We recommend <a href="https://0captcha.com/#comparision" target="_blank">0captcha</a>, which we co-develop, which is faster, more accurate and 3 times cheaper.</h1>
				captchaAlert = (
					<Alert
						message={message}
						type="error"
						closable      
					/>						
				)
			} else if (primaryGoogleCaptchaService == "TwoCaptcha") {
				let message = <>
					<span>We have just released <a href="https://0captcha.com">0captcha</a> is faster, more accurate and <b>3 times cheaper</b> than other captcha services.</span>
					<br/>
					<span>We strongly suggest that you use <b>0captcha</b>. <a href="https://0captcha.com/#comparision" target="_blank">Read more here</a></span>
				</>;
				captchaAlert = (
					<Alert
						message={message}
						type="success"
						closable      
					/>						
				)				
			}
			console.log("Primary Google Captcha", primaryGoogleCaptchaService);			
		}

		let notiComponent = "";
		if (this.state.notiMsg) {
			const noti = <div style={{fontSize: 'large'}} dangerouslySetInnerHTML={{__html: this.state.notiMsg}}></div>;
			notiComponent = <Alert message={noti} banner closable/>;			
		}	
		return (
			<Fragment>
				{ui.loadingCampaigns == true ? (
					""
				) : (
					<PageHeaderLayout breadcrumbList={breadcrumbList} title="Campaigns">
						{notiComponent}
						{captchaAlert}
						<Card>
							<AddCampaignDialog />
							<AddEditCampaignDialog />
							<DuplicateCampaignDialog />
							<Spin spinning={spinning}>
								<Row>
									<Form layout="inline" style={{ marginBottom: 8 }}>
										<FormItem>
											<Button
												type="primary"
												onClick={this.showAddCampaignDialog}
											>
												<Icon type="plus-square-o" />
											</Button>
										</FormItem>
										<FormItem>
											<Popconfirm
												title="Do you want to delete the selected campaigns?"
												place
												ment="bottom"
												onConfirm={this.deleteCampaigns}
											>
												<Button
													type="primary"
													disabled={this.state.selectedRowKeys.length == 0}
												>
													<Icon type="delete" />
												</Button>
											</Popconfirm>
										</FormItem>
										<FormItem>
											<Dropdown overlay={downloadLinkSetsMenu} disabled={selectedRowKeys.length == 0}>
												<Button type="primary">
													<Icon type="download" />
												</Button>
											</Dropdown>
										</FormItem>
									</Form>
								</Row>
								<Row>
									<Table
										rowKey="id"
										rowSelection={rowSelection}
										columns={columns}
										dataSource={campaigns}
										pagination={{
											pageSize: 100
										}}
									/>
								</Row>
							</Spin>
						</Card>
					</PageHeaderLayout>
				)}
			</Fragment>
		);
	}
}
